// extracted by mini-css-extract-plugin
export var acceptBtn = "CookieAcceptanceBanner-module--acceptBtn--af7e7";
export var banner = "CookieAcceptanceBanner-module--banner--0d754";
export var bannerContainer = "CookieAcceptanceBanner-module--bannerContainer--eb558";
export var text = "CookieAcceptanceBanner-module--text--02091";